[
  {
    "code": "AO-BGO",
    "name": "Bengo"
  },
  {
    "code": "AO-BGU",
    "name": "Benguela"
  },
  {
    "code": "AO-BIE",
    "name": "Bié"
  },
  {
    "code": "AO-CAB",
    "name": "Cabinda"
  },
  {
    "code": "AO-CCU",
    "name": "Cuando-Cubango"
  },
  {
    "code": "AO-CNO",
    "name": "Cuanza Norte"
  },
  {
    "code": "AO-CUS",
    "name": "Cuanza Sul"
  },
  {
    "code": "AO-CNN",
    "name": "Cunene"
  },
  {
    "code": "AO-HUA",
    "name": "Huambo"
  },
  {
    "code": "AO-HUI",
    "name": "Huíla"
  },
  {
    "code": "AO-LUA",
    "name": "Luanda"
  },
  {
    "code": "AO-LNO",
    "name": "Lunda Norte"
  },
  {
    "code": "AO-LSU",
    "name": "Lunda Sul"
  },
  {
    "code": "AO-MAL",
    "name": "Malange"
  },
  {
    "code": "AO-MOX",
    "name": "Moxico"
  },
  {
    "code": "AO-NAM",
    "name": "Namibe"
  },
  {
    "code": "AO-UIG",
    "name": "Uíge"
  },
  {
    "code": "AO-ZAI",
    "name": "Zaire"
  }
]